import { useEffect, useState } from "react";
import { IArticle } from "types";

export const useGetArticleList = (hash) => {
  const [articleList, setArticleList] = useState<IArticle[]>([]);
  const fetchFile = `/json/articleList${hash.substring(1)}.json`;

  useEffect(() => {
    const getArticleList = async () => {
      try {
        const res = await fetch(fetchFile);
        const data = await res.json();
        setArticleList(data);
      } catch (error) {
        console.log(error);
      }
    };
    getArticleList();
  }, []);

  return { articleList };
};
